<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix m-b-5">
      <h3 class="m-v-0 pull-left">成果申报</h3>
      <div class="pull-right" v-if="!pages.length">
        <el-button type="default" size="cons" @click="$router.back()">返回</el-button>
      </div>
    </div>
    <template v-if="pages.length>0">
      <div v-if="page_count > 1" class="page-title">
        处理第 {{current}} 批，共 {{page_count}} 批，本批共 {{pages.length}} 个
      </div>
      <div class="block" v-for="(achievement, achievement_index) in pages" :key="achievement.$$index">
        <icon class="remove" name="times-circle" scale="2"
              @click.native="removeAchievement(achievement_index)"></icon>
        <AchievementForm :achievement="achievement" :type="achievement.$$type" ref="form"
                         @update="achievement !== $event && $assign(achievement, $event)"
                         :teachers="is_admin ? teachers: null"
                         :key="achievement.$$index" :label_width="label_width + 'em'"></AchievementForm>
      </div>
      <div class="text-center m-v-10">
        <el-button type="primary" size="cons" @click="submit()" :loading="submit_loading>0">
          提交<span v-if="page_count > 1">，下一批</span>
        </el-button>
        <el-button type="default" size="cons" @click="$router.back()">取消</el-button>
      </div>
    </template>
    <div v-else class="empty-block">
      <div class="empty-text">没有数据</div>
    </div>
  </div>
</template>

<script>
import maxBy from 'lodash/maxBy'
import keyBy from 'lodash/keyBy'
import every from 'lodash/every'
import * as Achievement from 'api/achievement'
import * as Teacher from 'api/teacher'
import { toJSON } from 'utils/lang'
import { BATCH_ACHIEVEMENT, ADMIN_BATCH_ACHIEVEMENT } from 'constants/storage_keys'

import AchievementForm from './AchievementForm.vue'

export default {
  components: {AchievementForm},
  data () {
    let is_admin = this.$route.name === this.$location.admin_achievement_batch_edit().name
    return {
      list: [],
      submit_loading: 0,
      ready: false,
      label_width: 6,
      teachers: null,
      page: 10,
      page_count: null,
      pages: [],
      current: 0,
      storage_key: is_admin ? ADMIN_BATCH_ACHIEVEMENT : BATCH_ACHIEVEMENT,
    }
  },
  computed: {
    is_admin () {
      return this.$route.name === this.$location.admin_achievement_batch_edit().name
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [types, teachers] = await Promise.all([
          Achievement.types(),
          this.is_admin ? Teacher.list() : null,
        ])
        this.types = types
        this.type_map = keyBy(types, 'id')
        let list = JSON.parse(sessionStorage.getItem(this.storage_key)) || []
        this.setUp(list)
        this.list = list
        this.page_count = Math.ceil(this.list.length / this.page)
        this.nextPage()
        if (this.is_admin) this.teachers = teachers
        this.ready = true
      })
    },
    setUp (list) {
      list.forEach((achievement, index) => {
        achievement.$$index = index
        let type = this.type_map[achievement.type]
        achievement.name = type.name
        if (!this.is_admin) achievement.teacher_uid = undefined
        achievement.$$type = type
        let label_width = maxBy(type.form, item => item.name.length).name.length + 2
        if (this.label_width < label_width) this.label_width = label_width
      })
    },
    async submit () {
      if (!every(await Promise.all(this.$refs.form.map(form => this.$validate(form))))) return
      this.$guard(this, 'submit_loading')(async () => {
        while (this.pages.length) {
          let achievement = this.pages[0]
          await Achievement.edit(achievement)
          this.pages.splice(0, 1)
          if (this.pages.length) {
            sessionStorage.setItem(this.storage_key, toJSON(this.pages.concat(this.list)))
          }
        }
        this.$message.success('保存成功')
        if (!this.list.length) {
          this.$router.back()
          sessionStorage.removeItem(this.storage_key)
          return
        }
        this.nextPage()
      })
    },
    removeAchievement (index) {
      this.pages.splice(index, 1)
      if (!this.pages.length) this.nextPage()
      sessionStorage.setItem(this.storage_key, toJSON(this.pages.concat(this.list)))
    },
    nextPage () {
      if (!this.list.length) return
      this.pages = this.list.splice(0, this.page)
      this.current++
      sessionStorage.setItem(this.storage_key, toJSON(this.pages.concat(this.list)))
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.page-title {
  padding: 10px 0;
  text-align: center;
  font-weight: bold;
}

.block {
  padding: 20px;
  background-color: $color-block-background;
  margin-bottom: 10px;
  position: relative;
  .remove {
    position: absolute;
    top: -0.3em;
    right: -0.3em;
    display: none;
    color: $color-danger;
    cursor: pointer;
  }
  &:hover .remove {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/AchievementBatchEdit.vue